import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";
import "rxjs/add/operator/map";
import { UserBankService } from "./../../services/userbank.service";
import { UserVarifyService } from "./../../services/userVarify.service";
import { AlertService } from "./../../providers/alert.service";
import { DrawBanksModel } from "./../../models/drawBanks.model";
import { PageDefault } from "../../pages/PageDefault";
import { StorageService } from "./../../providers/storage.service";
import { SysconfigModel } from "../../models/user.model";
import { UserModel } from "../../models/user.model";
import { RechargeService } from "../../services/recharge.service";
import { ExchangeRateDto } from "../../models/transferRecord.model";

@Component({
  selector: "withdraw-key",
  templateUrl: "withdrawKey.html",
  providers: [UserBankService, UserVarifyService],
})
export class WithdrawKeyPage {
  constructor(
    public navCtrl: NavController,
    public ViewCtrl: ViewController,
    public navParams: NavParams,
    public userBankService: UserBankService,
    private userVarifyService: UserVarifyService,
    private alertService: AlertService,
    public storage: StorageService,
    private rechargeService: RechargeService
  ) {
    this.userPassWord = this.navParams.get("psw");
    this.withdrawUSDT = 0;
  }

  connect = this.storage.read<SysconfigModel>("sysconfig");
  times: Number;
  userInformation = this.storage.read<UserModel>("User");
  money: string;
  cards: DrawBanksModel[];
  cardSelect: DrawBanksModel;
  flagOne: boolean = false;
  userPassWord: string;
  // 提现手续费
  serviceCharge: number = 0.0;
  deduction: number = 0.0; //手续费扣费额度
  actualMoeny: number = 0.0;
  exchangeRate;
  withdrawUSDT: number;
  //页面加载后，判断用户能否可以提现
  //成功后加载用户的可提现银行卡，可提现次数，可提现金额
  ionViewDidLoad() {
    this.userVarifyService.getCashEnable().then((s) => {
      if (s.Result == false) {
        this.alertService.showAlert(s.Error);
      } else {
        this.userBankService
          .getUserBanks(PageDefault.PageIndex(), PageDefault.PageSize())
          .then((s) => {
            this.cards = s;
            this.cards.forEach((card) => {
              if (card.IsDefault == true) {
                this.cardSelect = card;
              }
            });
            this.cardSelect =
              this.cardSelect == undefined ? this.cards[0] : this.cardSelect;
          });
        this.userVarifyService.getCashTime().then((s) => {
          this.times = this.connect.WithDrawTimes - s;
        });
      }
    });
    this.getWidthdrawCharge();
    this.getUsdtSetting();
  }
  // 获取提现手续费
  getWidthdrawCharge() {
    this.userVarifyService.getServiceCharge().then((s) => {
      this.serviceCharge = s.WithdrawPercent;
    });
  }
  // 格式化小数乘法
  accMul(arg1, arg2) {
    var m = 0,
      s1 = arg1 + "",
      s2 = arg2 + "";
    try {
      m += s1.split(".")[1].length;
    } catch (e) {}
    try {
      m += s2.split(".")[1].length;
    } catch (e) {}
    return (
      (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
      Math.pow(10, m)
    );
  }
  //    计算手续费以及实际到账金额
  reset(money) {
    let Reg = /^[0-9]+(.[0-9]{0,3})?$/;
    let isNum = Reg.test(money);
    if (!isNum && money) {
      // debugger;
      let tempMoney;
      tempMoney = money + "";
      this.money = tempMoney.substr(0, tempMoney.length - 1);
    }

    if (this.money) {
      this.deduction = this.accMul(this.money, this.serviceCharge);

      this.actualMoeny = parseFloat(this.money) - this.deduction;

      const _usdtCount = this.actualMoeny / this.exchangeRate.Parameter2.ExchangeRate;
      this.withdrawUSDT = Number(
        _usdtCount
          .toString()
          .substring(0, _usdtCount.toString().indexOf(".") + 5)
      );

      let deductionPointLength = 0;
      if ((this.deduction + "").indexOf(".") >= 0) {
        deductionPointLength = (this.deduction + "").substr(
          (this.deduction + "").indexOf("."),
          (this.deduction + "").length
        ).length;
      }
      let actualMoenyLength = 0;
      if ((this.actualMoeny + "").indexOf(".") >= 0) {
        actualMoenyLength = (this.actualMoeny + "").substr(
          (this.actualMoeny + "").indexOf("."),
          (this.actualMoeny + "").length
        ).length;
      }
      if (deductionPointLength >= 4) {
        this.deduction = parseFloat(
          (this.deduction + "").substr(
            0,
            (this.deduction + "").indexOf(".") + 5
          )
        );
      }
      if (actualMoenyLength >= 4) {
        this.actualMoeny = parseFloat(
          (this.actualMoeny + "").substr(
            0,
            (this.actualMoeny + "").indexOf(".") + 5
          )
        );
      }
    }
  }
  //提交提现申请
  //chen 2017-01-04
  next() {
    if (this.times) {
      if (this.cardSelect.ID) {
        this.userVarifyService
          .getDrawMoney(this.userPassWord, this.money, this.cardSelect.ID)
          .then((s) => {
            this.alertService.showAlert(s.Error);
            this.close();
          });
      } else {
        this.alertService.showAlert("请选择提现银行卡");
      }
    } else {
      this.alertService.showAlert("您的提现条件不满足！");
    }
  }

  getUsdtSetting() {
    this.rechargeService.getUsdtSetting().then((result: ExchangeRateDto) => {
      if (result) {
        this.exchangeRate = result;
      }
    });
  }

  //选择提现银行卡
  //chen 2017-01-04
  option(obj) {
    this.cardSelect = obj;
  }

  //关闭提现信息窗口
  //chen 2017-01-04
  close() {
    this.ViewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/withdraw/withdrawKey.ts